export const ResidentialAccountType = [
  'DStvRes',
  'Residential General'
];